import { candidates } from "../controllers";

export const convertCandidateOfferRequest = (
    candidateConcurrencyToken: string
): candidates.CandidateOfferRequest => {
    const offer: candidates.CandidateOfferRequest = {
        candidateConcurrencyToken: candidateConcurrencyToken,
    };
    return offer;
};
